import React from 'react';
import type { Driver, Member } from '@hero/schema';
import { MemberEditModal } from '../../User/Modal/MemberEditModal';

export interface DriverCreateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDriverSaved?: (driver: Driver) => void;
}

export function DriverCreateModal({
  isOpen,
  onClose,
  onDriverSaved,
}: DriverCreateModalProps) {
  return (
    <MemberEditModal
      isOpen={isOpen}
      onClose={onClose}
      displayForUser="carrier"
      forceType="driver"
      onMemberSaved={member => {
        if (member && onDriverSaved) {
          onDriverSaved(memberToDriver(member));
        }
        onClose();
      }}
    />
  );
}

function memberToDriver(member: Member): Driver {
  const full = member.driverFullInfo;
  return {
    _id: member._id,
    name: member.name,
    phone: member.phone,
    status: full?.status ?? 'pending',
    rating: full?.rating ?? 0,
    type: full?.type ?? 'company',
    vehicle: full?.vehicle,
    org: full?.org,
    userId: member.userId,
    UTags: full?.UTags ?? [],
  } as Driver;
}
